import { postRequest, getRequest } from "app/axiosClient";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import {
  setAppointmentByApptId,
  setAppointmentsList,
  setTechnicianAvailability,
  setAppointmentItemsList,
  setAppointmentDetails,
  setTechFieldList,
  validateAppointmentRequest,
  setAppointmentsByDateList,
  setAppointmentCount,
} from "./AppointmentSlice";
import {
  getAppointmentsByDate,
  getAppointmentCountByStatusId,
} from "features/Dispatch/DispatchApi";
import { uploadAttachment } from "CommonComponents/Attachments/AttachmentsAPI";
import { message } from "antd";
import StatusEnum from "features/Enums/StatusEnum";
import { GetWorkOrderByIdApi } from "../ClientsApi";

export const getAppointmentsByWOId =
  (workOrderId, pagination) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(
        `api/Appointment/GetAppointmentsByWOId?workOrderId=${workOrderId}`,
        pagination
      )
        .then((res) => {
          dispatch(
            setAppointmentsList({
              data: res?.data?.items,
              totalPages: res?.data?.totalPages,
            })
          );
          dispatch(hideLoader());
        })
        .catch((e) => {
          dispatch(hideLoader());
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Clients.Notification.UnexpectedError",
        "",
        "AddAppointment.Notification.Anunexpectederroroccurred"
      );
    }
  };

export const addAppointmentForWOAPI = (apptObj, pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Appointment/AddAppointmentForAWO`, apptObj)
      .then((res) => {
        dispatch(getAppointmentsByWOId(apptObj.WorkOrderId, pagination));
        dispatch(
          getAppointmentsByDate({
            startDate: apptObj.StartDate,
            pageNo: 1,
            pageSize: 24,
          })
        );

        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          `${res?.data?.appointmentNumber}`,
          "AddAppointment.Notification.AppointmentAddedSuccessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        const errorMessage =
          e?.response?.data?.message || e?.response?.data || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
        return false;
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "AddAppointment.Notification.Anunexpectederroroccurredwhileaddingappointment"
    );
    return false;
  }
};

export const deleteAppointmentsByApptId =
  (appointmentId, workOrderId, pagination, date) => (dispatch) => {
    try {
      dispatch(showLoader());
      return postRequest(
        `api/Appointment/DeleteAppointmentByApptId/${appointmentId}`
      )
        .then((res) => {
          dispatch(getAppointmentsByWOId(workOrderId, pagination));
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "AddAppointment.Notification.Appointmentdeleted"
          );
          return res;
        })
        .catch((e) => {
          dispatch(hideLoader());
          return false;
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Clients.Notification.UnexpectedError",
        "",
        "AddAppointment.Notification.Anunexpectederroroccurredwhiledeletingappointment"
      );
      return false;
    }
  };

export const getTechnicianAvailability =
  (startDate, startTime, endTime) => (dispatch) => {
    try {
      dispatch(showLoader());
      return getRequest(
        `api/Appointment/GetTechniciansAvailability?startDate=${startDate}&startTime=${startTime}&endTime=${endTime}`
      )
        .then((res) => {
          dispatch(setTechnicianAvailability(res?.data || []));
          dispatch(hideLoader());
          return res?.data;
        })
        .catch((e) => {
          dispatch(hideLoader());
          return false;
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Clients.Notification.UnexpectedError",
        "",
        "AddAppointment.Notification.Anerroroccurredwhileretrievingappointmentdetails"
      );
      return false;
    }
  };

export const updateAppointmentForWOAPI =
  (apptObj, pagination) => (dispatch) => {
    try {
      dispatch(showLoader());
      return postRequest(`api/Appointment/UpdateAppointmentForAWO`, apptObj)
        .then((res) => {
          dispatch(getAppointmentsByWOId(apptObj.WorkOrderId, pagination));
          dispatch(
            getAppointmentsByDate({
              startDate: apptObj.StartDate,
              pageNo: 1,
              pageSize: 24,
            })
          );
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "AddAppointment.Notification.Appointmenthasbeenupdatedsuccessfully"
          );
          return res?.data;
        })
        .catch((e) => {
          const errorMessage =
            e?.response?.data?.message || e?.response?.data || e?.message;
          dispatch(hideLoader());
          OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
          return false;
        });
    } catch {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "AddAppointment.Notification.Anunexpectederroroccurredwhileupdatingappointment"
      );
      return false;
    }
  };

export const getAppointmentDetailsByApptId = (appointmentId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Appointment/GetAppointmentDetailsByApptId/${appointmentId}`)
      .then((res) => {
        dispatch(setAppointmentByApptId(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Clients.Notification.UnexpectedError",
      "",
      "AddAppointment.Notification.Anerroroccurredwhileretrievingappointmentdetails"
    );
  }
};
export const getAppointmentById = (appointmentId) => (dispatch) => {
  try {
    dispatch(showLoader());

    getRequest(`api/Appointment/GetAppointmentByApptId/${appointmentId}`)
      .then((res) => {
        dispatch(
          setAppointmentDetails({
            data: res?.data,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Appointments.Notification.FailedToFetchAppointmentDetails"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Appointment.Notification.AnUnexpectedErrorOccurred"
    );
  }
};

export const getAppointmentItemsList = (appointmentId) => (dispatch) => {
  try {
    dispatch(showLoader());

    getRequest(
      `api/Appointment/GetAppointmentItems?appointmentId=${appointmentId}`
    )
      .then((res) => {
        dispatch(
          setAppointmentItemsList({
            data: res?.data,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Appointment.Notification.Anunexpectederroroccurred"
    );
  }
};
export const addAppointmentItem = (payload, appointmentId) => (dispatch) => {
  try {
    dispatch(showLoader());

    postRequest(`api/Appointment/AddAppointmentItem`, payload)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Appointment.Notification.ItemAddedSuccessfully"
        );
        dispatch(getAppointmentItemsList(appointmentId));
        dispatch(GetWorkOrderByIdApi(payload.workOrderId));
      })
      .catch(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Appointment.Notification.FailedToAddItem"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Appointment.Notification.AnUnexpectedErrorOccurred"
    );
  }
};
export const updateAppointmentItem = (id, payload) => (dispatch) => {
  try {
    dispatch(showLoader());

    postRequest(`api/Appointment/UpdateAppointmentItem?id=${id}`, payload)
      .then(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Appointment.Notification.ItemUpdatedSuccessfully"
        );
        dispatch(getAppointmentItemsList(payload.appointmentId));
      })
      .catch(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Appointment.Notification.FailedToUpdateItem"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Appointment.Notification.AnUnexpectedErrorOccurred"
    );
  }
};
export const deleteAppointmentItem = (id, appointmentId) => (dispatch) => {
  try {
    dispatch(showLoader());

    postRequest(`api/Appointment/DeleteAppointmentItem?id=${id}`)
      .then(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Appointment.Notification.ItemDeletedSuccessfully"
        );
        dispatch(getAppointmentItemsList(appointmentId));
      })
      .catch(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Appointment.Notification.FailedToDeleteItem"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Appointment.Notification.AnUnexpectedErrorOccurred"
    );
  }
};
export const getFieldStatusesByAppointmentId =
  (appointmentId) => (dispatch) => {
    try {
      dispatch(showLoader());

      getRequest(
        `api/Appointment/GetFieldStatusesByAppointmentId?appointmentId=${appointmentId}`
      )
        .then((res) => {
          dispatch(hideLoader());
          dispatch(
            setTechFieldList({
              data: res?.data,
            })
          );
        })
        .catch(() => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "AppointmentFieldStatus.Notification.FailedToFetch"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "AppointmentFieldStatus.Notification.AnUnexpectedErrorOccurred"
      );
    }
  };

export const addAppointmentFieldStatus = (data) => (dispatch) => {
  try {
    dispatch(showLoader());

    postRequest(`api/Appointment/AddFieldTechnicianStatus`, data)
      .then(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "AppointmentFieldStatus.Notification.AddedSuccessfully"
        );
        dispatch(getFieldStatusesByAppointmentId(data.appointmentId));
      })
      .catch(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "AppointmentFieldStatus.Notification.FailedToAdd"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "AppointmentFieldStatus.Notification.AnUnexpectedErrorOccurred"
    );
  }
};
export const updateAppointmentFieldStatus = (id, data) => (dispatch) => {
  try {
    dispatch(showLoader());

    postRequest(`api/Appointment/UpdateFieldTechnicianStatus?id=${id}`, data)
      .then(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "AppointmentFieldStatus.Notification.UpdatedSuccessfully"
        );
        dispatch(getFieldStatusesByAppointmentId(data.appointmentId));
      })
      .catch(() => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "AppointmentFieldStatus.Notification.FailedToUpdate"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "AppointmentFieldStatus.Notification.AnUnexpectedErrorOccurred"
    );
  }
};
export const deleteAppointmentFieldStatus =
  (id, appointmentId) => (dispatch) => {
    try {
      dispatch(showLoader());

      postRequest(`api/Appointment/DeleteFieldTechnicianStatus?id=${id}`)
        .then(() => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "AppointmentFieldStatus.Notification.DeletedSuccessfully"
          );
          dispatch(getFieldStatusesByAppointmentId(appointmentId));
        })
        .catch(() => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "AppointmentFieldStatus.Notification.FailedToDelete"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "AppointmentFieldStatus.Notification.AnUnexpectedErrorOccurred"
      );
    }
  };
export const updateAppointmentNotes =
  ({ appointmentId, notes }) =>
  (dispatch) => {
    try {
      dispatch(showLoader());

      const encodedNotes = encodeURIComponent(notes);
      const url = `api/Appointment/UpdateAppointmentNotes?appointmentId=${appointmentId}&notes=${encodedNotes}`;

      postRequest(url)
        .then(() => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Appointment.Notes.Notification.UpdatedSuccessfully"
          );
          dispatch(uploadAttachment(appointmentId));
        })
        .catch(() => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Appointment.Notes.Notification.FailedToUpdate"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Appointment.Notes.Notification.AnUnexpectedErrorOccurred"
      );
    }
  };
export const updateAppointmentStatus =
  (appointmentId, appointmentStatusId) => async (dispatch) => {
    dispatch(showLoader());

    try {
      const res = await postRequest(
        `api/Appointment/UpdateAppointmentStatus?appointmentId=${appointmentId}&appointmentStatusId=${appointmentStatusId}`
      );

      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "success",
        "Common.Success",
        "",
        "Appointment.Notification.AppointmentStatusUpdatedSuccessfully"
      );
      dispatch(getAppointmentById(appointmentId));
      return true;
    } catch (e) {
      const errorMessage = e?.response?.data;
      dispatch(hideLoader());
      OpenNotificationWithIcon("error", "Common.Error", "", errorMessage);
      throw e;
    }
  };

export const validateAppointmentRequestAPI = (token) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(
      `api/Appointment/ValidateTechnicianAppointmentRequest?token=${token}`
    )
      .then((res) => {
        dispatch(validateAppointmentRequest(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        message.error(
          "Error",
          "Impossible de valider la demande de devis. Veuillez réessayer."
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    message.error(
      "Error",
      "Impossible de valider la demande de devis. Veuillez réessayer."
    );
  }
};

export const technicianStatusChangeAPI = (statusObj) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Appointment/UpdateTechnicianStatus`, statusObj)
      .then((res) => {
        dispatch(hideLoader());
        if (StatusEnum?.Approved?.id === statusObj?.technicianStatusId) {
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Your appointment has been approved."
          );
        } else if (StatusEnum?.Declined?.id === statusObj?.technicianStatusId) {
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Your appointment has been declined."
          );
        }
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Authenticate.Notification.Unabletoprocesstherequest"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Authenticate.Notification.Unabletoprocesstherequest"
    );
  }
};

export const subContractorStatusChangeAPI = (statusObj) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Appointment/UpdateSubContractorStatus`, statusObj)
      .then((res) => {
        dispatch(hideLoader());
        if (StatusEnum?.Approved?.id === statusObj?.subContractorStatusId) {
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Your appointment has been approved."
          );
        } else if (StatusEnum?.Declined?.id === statusObj?.technicianStatusId) {
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Your appointment has been declined."
          );
        }
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Authenticate.Notification.Unabletoprocesstherequest"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Authenticate.Notification.Unabletoprocesstherequest"
    );
  }
};
